import HeaderRegionDashboard from './HeaderRegionDashboard';

export default HeaderRegionDashboard;
